import React from 'react';
import {
  useHistory
} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import NoMatchImage from './assets/404.png';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  center: {
    textAlign: 'center',
  },
}));

const NoMatch = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={classes.root}>
      <Container className={classes.center}>
        <img alt="" src={NoMatchImage} style={{ width: '80%', marginTop: 100, marginBottom: 30 }} />
        <Button
              onClick={() => history.push('/')}
              variant="contained"
              color="primary"
              disableElevation
            >
              Go To Home
            </Button>
      </Container>
    </div>
  );
};

export default NoMatch;